import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userInvoiceNotificationMessages = {
  [AutomationEventTypes.TimeAfterInvoiceDue]: {
    subject: 'Invoice Overdue – *|RENTAL:NAME|*',
    message: `
      Hi Team,

      We wanted to let you know that the following invoice has not yet been paid:
      Invoice Number: *|INVOICE:NUMBER|*
      Due Date: *|INVOICE:DUE_DATE|*
      Amount Due: *|INVOICE:AMOUNT|*

      We request that you settle this payment as soon as possible. For your convenience, you can make a payment via the following link:
      *|INVOICE:LINK|*
      `,
  },
}

export const guestInvoiceNotificationMessages = {
  [AutomationEventTypes.InvoiceCreated]: {
    subject: 'Invoice Created – *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We have created a new invoice for your upcoming stay. Please find the details below. If you have any questions about this invoice or need to make changes, feel free to contact us.

      Invoice Details:
      Invoice Number: *|INVOICE:NUMBER|*
      Amount Due: *|INVOICE:AMOUNT|*
      Due Date: *|INVOICE:DUE_DATE|*
      To make a payment, please use the following link:
      *|INVOICE:LINK|*

      Thank you for your prompt attention to this matter. We look forward to hosting you at *|RENTAL:NAME|*.
    `,
  },
  [AutomationEventTypes.InvoicePaid]: {
    subject: 'Thank You for Your Payment – *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We are pleased to confirm that we have successfully received your payment for the following invoice:

      Invoice Details:
      Invoice Number: *|INVOICE:NUMBER|*
      Amount Paid: *|INVOICE:AMOUNT|*
      Payment Date: *|INVOICE:PAID_DATE|*
      Payment Method: *|INVOICE:PAID_METHOD|*

      Thank you for your prompt payment! We hope you enjoy your stay at *|RENTAL:NAME|*.
      `,
  },
  [AutomationEventTypes.TimeAfterInvoiceDue]: {
    subject: 'Invoice Overdue – *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      This is a friendly reminder that your payment for Invoice #*|INVOICE:NUMBER|* is due on *|INVOICE:DUE_DATE|*. As of today, we have not yet received your payment.

      Invoice Details:
      Invoice Number: *|INVOICE:NUMBER|*
      Amount Due: *|INVOICE:AMOUNT|*
      Due Date: *|INVOICE:DUE_DATE|*
      To make the payment, please use the following link:
      *|INVOICE:LINK|*

      If you have already made the payment, please disregard this reminder. Otherwise, we kindly request that you process the payment at your earliest convenience. If there are any issues or questions regarding the payment, please don’t hesitate to reach out to us.
      Thank you for your attention to this matter. We truly value your upcoming stay at *|RENTAL:NAME|*
    `,
  },
}
